module.exports = __webpack_public_path__ + "static/media/icon-change-ingredient-done.44f8ca7a.svg";